import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import imaaage from '../assets/images/post.jpg'

const MainContainer = styled.div`
  margin: 20px 100px 100px 100px;

  @media (max-width: 768px) {
    margin: 20px 50px 50px; 
  }
  @media (max-width: 480px) {
    margin: 10px 20px 20px; 
  }
`;

const CarouselContainer = styled.div`
  position: relative;
  display: flex; 
  flex-wrap: wrap;
  justify-content: center;
  overflow-x: auto; 
  padding: 10px 0;
  gap: 50px; 

  @media (max-width: 768px) {
    gap: 10px; 
  }

  @media (max-width: 480px) {
    flex-direction: column; 
    align-items: center; 
    gap: 15px;
  }
`;

const Slide = styled.div`
  width: 300px; 
  height: 300px;
  position: relative;
  flex-shrink: 0; /* Prevent shrinking */
  border-radius: 20px; 
  overflow: hidden; 
  transition: transform 0.5s ease; 

  &:hover {
    transform: translateY(-5px); 
    cursor:pointer;
  }

  @media (max-width: 768px) {
    width: 200px; 
    height: 200px;
  }

  @media (max-width: 480px) {
    width: 70%; 
    height: auto;
  }
`;

const SlideImage = styled.img`
  width: 100%; 
  height: 100%;
  object-fit: cover; 
  border-radius: 20px; 
  transition: transform 0.8s ease; 

  &:hover {
    transform: scale(1.1); 
  }

  @media (max-width: 768px) {
    border-radius: 15px; 
  }

  @media (max-width: 480px) {
    border-radius: 10px; 
  }
`;

const Overlay = styled.div`
  position: absolute;
  bottom: 0; 
  left: 0; 
  right: 0; 
  color: white; 
  background: rgba(0, 0, 0, 0.4); 
  padding: 10px; 
  border-radius: 5px; 
  text-align: left; 

  h3 {
    font-size: 18px;
    font-weight: 350;
    margin: 10px;

    @media (max-width: 768px) {
      font-size: 14px; 
    }

    @media (max-width: 480px) {
      font-size: 12px; 
      margin: 5px; 
    }
  }
`;

const Title = styled.div`
   font-size: 40px;
   display:flex;
   justify-content: center;
   color: #385963;
   font-weight: 600;
   margin-bottom: 10px;

   @media (max-width: 768px) {
    font-size: 30px;
  }

  @media (max-width: 480px) {
    font-size: 24px; 
    text-align: center; 
  }
`;

// File type constants
const FILE_PLACE_TYPE = {
  Gallery: 0,
  CategoryPhoto: 1,
  CoverPhoto: 2,
  Poster: 3,
};

const ExperiencesCategories = ({ categoryId }) => {

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const tokenString = sessionStorage.getItem("token");
  const { i18n } = useTranslation();
  const selectedLanguage = sessionStorage.getItem('selectedLanguage') || 'en';
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [activeComponent, setActiveComponent] = useState(state?.activeComponent);

  useEffect(() => {
    if (state?.activeComponent) {
      setActiveComponent(state.activeComponent);
    }
  }, [state]);

  const [experiences, setExperiences] = useState([]);

  useEffect(() => {
    const fetchExperienceCategories = async () => {
      try {
        const response = await fetch(`${BASE_URL}Experience/getByCategory/${categoryId}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        const rawFileNames = data.flatMap(d => d.fileNames || []);

        // Only keep files that start with "CategoryPhoto_"
        const categoryPhotoFileNames = rawFileNames.filter(name =>
          name.startsWith("CategoryPhoto_")
        );
        
        let fetchedFiles = [];
        if (categoryPhotoFileNames.length > 0) {
          const fileResponse = await fetch(`${BASE_URL}Experience/getFiles`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${tokenString}`,
            },
            body: JSON.stringify(categoryPhotoFileNames),
          });



          if (!fileResponse.ok) throw new Error('Failed to fetch file contents');
          fetchedFiles = await fileResponse.json();
        }

        const updatedExperiences = data.map(exp => {
          const categoryFile = fetchedFiles.find(
            f =>
              f.filePlaceType === FILE_PLACE_TYPE.CategoryPhoto &&
              exp.fileNames?.includes(f.fileName)
          );

          const categoryBase64Src = categoryFile
            ? `data:${categoryFile.mimeType};base64,${categoryFile.base64Content}`
            : null;

          return {
            ...exp,
            categoryBase64Src,
          };
        });

        setExperiences(updatedExperiences);

      } catch (error) {
        if (error.message.includes('404')) {
          console.error(`Category ID not found: ${error.message}`);
        } else {
          console.error('Error fetching data:', error);
        }
      }
    };

    if (categoryId) {
      fetchExperienceCategories();
    }
  }, [categoryId]);

  const handleClick = (id) => {
    navigate('/experiences', { state: { activeComponent: 'ExperienceTemplate', experienceId: id, category: 'experience' } });
  };

  return (
    <MainContainer>
      <CarouselContainer>
        {experiences.map((experience, index) => (
          <Slide key={experience.id} onClick={() => handleClick(experience.id)}>
              {/* <SlideImage src={imaaage} alt={experience.name[selectedLanguage] || experience.name['en']} />    */}
           <SlideImage
              src={
                experience.categoryBase64Src || "Loading..."
              }
              alt={experience.name[selectedLanguage] || experience.name['en']}
            />
            <Overlay>
              <h3>{experience.name[selectedLanguage]}</h3>
            </Overlay>
          </Slide>
        ))}
      </CarouselContainer>
    </MainContainer>
    
  );
};

export default ExperiencesCategories;
